/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// TODO: move this to package.json:exports
// Metro uses this entrypoint to interact with the asset registry
module.exports = require('./dist/cjs/exports/AssetRegistry');
